import { lazy, Suspense } from 'react';
import { Col, Container, Row } from 'reactstrap';
import './App.css';

const Header = lazy(() => import('./components/Header/Header'));
const AppRouter = lazy(() => import('./routing.component'));
const Footer = lazy(() => import('./components/Footer/Footer'));

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <Container fluid>
          <Row>
            <Col>
              <Row>
                <Header />
              </Row>
              <Row>
                <AppRouter />
              </Row>
              <Row>
                <Footer />
              </Row>
            </Col>
          </Row>
        </Container>
      </Suspense>
    </div>
  );
}

export default App;
